<template>
  <div class="insight-details" v-if="insight">
    <router-link class="link-back" :to="`/test/${$route.params.id}/insights`">
      <div>&larr; Back to Insights</div>
    </router-link>
    <div class="top-bar">
      <h1 v-bg-typography="'h1'">
        {{ insight.assigned_id }}. <span v-html="coloredTitle"></span>
      </h1>
      <div class="arrows">
        <div class="arrow" @click="previous">
          <bg-icon name="chevronLeft"></bg-icon>
        </div>
        <div class="arrow" @click="next">
          <bg-icon name="chevronRight"></bg-icon>
        </div>
      </div>
    </div>
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>

    <div class="highlighted" v-if="participant && !isLoading">
      <div class="quote">
        <div class="top">
          <p>
            <b
              >Highlighted
              <span
                v-if="
                  insight.highlighted_significant_point.emotion ===
                    'frustration'
                "
                style="color: #FF14A9;"
                >frustration</span
              ><span
                v-if="
                  insight.highlighted_significant_point.emotion === 'attention'
                "
                style="color: #F1C40F;"
                >attention</span
              ><span
                v-if="insight.highlighted_significant_point.emotion === 'joy'"
                style="color: #00DEAB;"
                >joy</span
              ><span
                v-if="insight.highlighted_significant_point.emotion === 'manual'"
                style="color: #636383;"
                >feedback</span
              >
              moment
            </b>
          </p>
        </div>
        <div class="text" v-if="insight && $store.state.test">
          <img id="fakeperson" :src="fakePerson" alt="" />
          <p>
            <i
              >“{{
                $store.state.test.translation
                  ? insight.highlighted_significant_point.translation
                  : insight.highlighted_significant_point.comment
              }}”</i
            >
          </p>
        </div>
        <bg-button
          style="margin-top: 30px;"
          @click="openHighlight"
          text="Watch video"
        ></bg-button>
        <img id="triangle" src="@/assets/imgs/triangle.svg" alt="" />
      </div>
      <div class="video" v-if="this.participant">
        <video
          :key="this.participant.video"
          id="video"
          autoplay
          muted
          @play="videoLoop"
          ref="videoPlayer"
        >
          <source :src="this.participant.video" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>

    <div class="notes" v-if="!isLoading">
      <div>
        <h3 v-bg-typography="'h3'" style="margin-bottom: 10px;">Data</h3>
        <div class="data">
          <p v-html="insight.eeg_comment"></p>
          <p v-html="insight.eye_tracking_comment"></p>
          <p v-html="insight.behavior_comment"></p>
          <p v-html="insight.touch_tracking_comment"></p>
        </div>
      </div>
      <div>
        <h3 v-bg-typography="'h3'" style="margin-bottom: 10px;">Explanation</h3>
        <div class="explanation"><p v-html="insight.explanation"></p></div>
      </div>
    </div>

    <div class="suggestionhead" v-if="!isLoading">
      <h3 v-bg-typography="'h3'">Suggestions</h3>
    </div>
    <div
      class="old-suggestions"
      v-if="
        insight.suggestion != '' &&
          insight.suggestion != '<p></p>' &&
          !isLoading
      "
    >
      <p v-html="insight.suggestion"></p>
    </div>
    <div
      v-if="
        filtered.length === 0 &&
          (insight.suggestion === '' || insight.suggestion === '<p></p>') &&
          !isLoading
      "
    >
      <p style="margin-bottom: 25px;">
        There are no suggestions added yet. Go to
        <span
          @click="$router.push(`/test/${$route.params.id}/suggestions`)"
          style="cursor: pointer;"
          ><u>suggestions</u></span
        >
        to add some!
      </p>
    </div>
    <div class="suggestions" v-if="!isLoading && filtered.length > 0">
      <div
        class="suggestion"
        v-for="(suggestion, index) in filtered"
        :key="index"
        @mouseover="showArrow = index"
        @mouseleave="showArrow = null"
        @click="
          $router.push(`/test/${$route.params.id}/suggestions/${suggestion.id}`)
        "
      >
        <div>
          <p style="margin-bottom: 5px;">
            <b>{{ suggestion.title }}</b>
          </p>
          <p v-html="suggestion.suggestion"></p>
        </div>
        <transition name="slide-fade">
          <bg-icon name="chevronRight" v-if="showArrow === index"></bg-icon>
        </transition>
      </div>
    </div>

    <div
      style="display: flex; align-items: center; justify-content: space-between"
      v-if="!isLoading"
    >
      <h3 v-bg-typography="'h3'" style="margin-bottom: 10px;">
        Supporting data
      </h3>
      <p
        style="cursor: pointer; font-size: 10pt; margin-bottom: 10px;"
        @click="
          $store.commit('SET_TEST_TRANSLATION', !$store.state.test.translation)
        "
      >
        <u>
          {{
            $store.state.test.translation
              ? "Original"
              : $store.state.test.translation_language
          }}</u
        >
      </p>
    </div>
    <div
      class="insight-details__supporting-data"
      v-if="!isLoading && insight.significant_points.length > 0"
    >
      <bg-detail-card
        v-for="significantPoint in insight.significant_points"
        :key="significantPoint.id"
        v-bind="{ ...significantPoint }"
        :text="
          $store.state.test.translation
            ? significantPoint.translation
            : significantPoint.comment
        "
        :detail="significantPoint.emotion"
        @click.native="handleTimeClick(significantPoint)"
        actionIcon="videos"
        actionText="Watch recording"
        :actionTextTarget="`Participant ${significantPoint.participant_id}`"
      />
    </div>
  </div>
</template>

<style scoped>
@import "./styles.css";
</style>

<style>
.insight-details__data ul,
ol,
li {
  list-style-type: circle !important;
  list-style-position: inside !important;
}
.insight-details__notes ul,
ol,
li {
  list-style-type: circle !important;
  list-style-position: inside !important;
}

.insight-details__data li p {
  display: inline;
}
.insight-details__notes li p {
  display: inline;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import BgLoader from "@/components/bg-loader";
import BgDetailCard from "@/components/bg-detail-card";
import BgIcon from "@/components/bg-icon";
import API from "@/api";
import BgButton from "@/components/bg-button";

export default {
  name: "insight",
  components: {
    BgLoader,
    BgDetailCard,
    BgIcon,
    BgButton,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      interval: null,
      isLoading: true,
      insight: null,
      insights: [],
      suggestions: [],
      participant: null,
      start: null,
      end: null,
      showArrow: null,
    };
  },
  watch: {
    "$route.params.id": function() {
      this.fetchData();
    },
    "$route.params.insightId": function() {
      this.fetchData();
    },
  },
  methods: {
    async fetchData() {
      this.isInsightLoading = true;
      const testId = this.$route.params.id;
      const insightId = this.$route.params.insightId;
      await API.test.getInsight(testId, insightId).then((res) => {
        this.insight = res.data;
        this.isInsightLoading = false;
      });

      const response = await API.test.getInsights(testId);
      this.insights = response.data.insights;

      const suggestions = await API.test.getSuggestions(this.$route.params.id);
      this.suggestions = suggestions.suggestions;
      if (this.insight.highlighted_significant_point) {
        const res = await API.test.getParticipant(
          this.$route.params.id,
          this.insight.highlighted_significant_point.participant_id
        );
        this.participant = res;
        this.start = Math.floor(
          (this.insight.highlighted_significant_point.timestamp_top -
            res.started_at -
            3000) /
            1000
        );
        this.end = this.start + 7;
        const tag = `#t=${this.start},${this.end}`;
        this.participant.video = this.participant.video.concat(tag);
        this.videoLoop();
      }
      this.isLoading = false;
    },
    handleTimeClick(detail) {
      const testId = this.$route.params.id;
      const routeObj = {
        path: `/test/${testId}/participant/${detail.participant_id}/recording`,
        query: {
          timestamp: detail.timestamp_top,
          sp_id: detail.id,
        },
      };
      let routeData = this.$router.resolve(routeObj);
      window.open(routeData.href, "_blank");
    },
    next() {
      let next = this.insights.find(
        (el) => el.assigned_id === this.insight.assigned_id + 1
      );

      if (next) {
        this.$router.push(`/test/${this.$route.params.id}/insights/${next.id}`);
      }
    },
    previous() {
      let previous = this.insights.find(
        (el) => el.assigned_id === this.insight.assigned_id - 1
      );

      if (previous) {
        this.$router.push(
          `/test/${this.$route.params.id}/insights/${previous.id}`
        );
      }
    },
    openHighlight() {
      window.open(this.linkToHighlight, "_blank");
    },
    videoLoop() {},
  },
  computed: {
    fakePerson: function() {
      return require(`@/assets/imgs/fakepeople/${
        this.participant.demographic.gender
      }${this.participant.id}.jpeg`);
    },
    linkToHighlight() {
      const testId = this.$route.params.id;
      const detail = this.insight.highlighted_significant_point;
      const routeObj = {
        path: `/test/${testId}/participant/${detail.participant_id}/recording`,
        query: {
          timestamp: detail.timestamp_top,
          sp_id: detail.id,
        },
      };
      let routeData = this.$router.resolve(routeObj);
      return routeData.href;
    },
    coloredTitle: function() {
      let title = this.insight.title.split(" ");
      title.forEach((word, index) => {
        if (word.toLowerCase() === "frustration") {
          title[index] = `<span style='color: #FF14A9;'>${word}</span>`;
        } else if (word.toLowerCase() === "attention") {
          title[index] = `<span style='color: #F1C40F;'>${word}</span>`;
        } else if (word.toLowerCase() === "joy") {
          title[index] = `<span style='color: #00DDAB;'>${word}</span>`;
        }
      });
      return title.join(" ");
    },
    filtered() {
      let filtered = this.suggestions.filter(
        (el) => el.insight_id === this.insight.id
      );
      return filtered;
    },
  },
  mounted() {
    this.fetchData();
    const vm = this;
    this.interval = setInterval(function() {
      vm.$refs.videoPlayer.currentTime = vm.start;
    }, 7000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
